<template>
    <div>
    </div>
</template>

<script>

import Session from 'common/session'
import Echo from "laravel-echo"


export default {
	name:"broadcast",
  components:{},
	mixins: [Session],

	data () {
       return {
        pusher:null,
       }
    },

    created(){
    },
    beforeDestroy(){
			window.Echo = null;
		},

    mounted(){
      this.inicialize();
    },

    watch:{
    },  

    methods:{

      inicialize(){

        if(false && !window.Echo){
          window.io = require('socket.io-client');
          window.Echo = new Echo({
            broadcaster: 'socket.io',
            key: process.env.PUSHER_KEY,
            host: process.env.URL_API.web + ':6001'
          });
        }
        
      },

      onBroadcast(_channel,_event,_onEvent,_notClear){
        var self = this;

        _channel = (this.cliente.logged ? this.cliente.logged.id : '0')+(_channel ? '.'+_channel : '');
        _event = (this.cliente.logged ? this.cliente.logged.id : '0')+(_event ? '.'+_event : '');;

        // var channel = window.Echo.channel(_channel);

        // channel.listen(_event, function(data) {

        //   if(_onEvent){
        //     this.$events.fire(_onEvent, data);
        //   }
            
        // },this);

      },

      unSubscribe: function(_channel){
        this.pusher.unsubscribe(_channel);
      },

      sendBroadcastEvent: function(_channel,_event,_data){

      }

    }
}

</script>


// WEBPACK FOOTER //
// broadcast.vue?6469fdeb